<template>
    <section v-if="servicio"  class="content" style="margin-top: -20px;">
        <div class="row" v-if="servicio.estado != 'Finalizado'">
            <div class="col-md-8">
                <facturacionfacturar ref="fac" :id="id" :servicio="servicio" :ffac="ffac" />
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header bg-gray">
                        <h3 class="card-title"><i class="fas fa-sign-out-alt mr-2"></i>No {{no_factura==1?'Registrar': $t('general.facturar')}}
                        </h3>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <button class="btn btn-block btn-info" @click="finalizarSinFacturar()"
                            type="button">{{no_factura==1?'Finalizar sin registro':$t('general.finalizar sin factura')}}</button>
                    </div>
                </div>
                <facturacionlistado ref="listado" :togglecargar="togglecargar" :id="id" :servicio="servicio" />
            </div>
        </div>
        <div class="row" v-if="servicio.estado == 'Finalizado'">
            <div class="col-md-12">
                <facturacionlistado ref="listado" :servicioext="servicioext" :togglecargar="togglecargar" :id="id" :servicio="servicio" />
            </div>
        </div>
    </section>
</template>
<script>
//Iconos en https://fontawesome.com/v5/search?m=free&s=solid%2Cbrands
import { PwgsApi } from '../../../../services/PwgsApi';
import facturacionfacturar from './FacturacionFacturar.vue'
import facturacionlistado from './FacturacionListado.vue'
//import Dialog from 'primevue/dialog'; 
export default {
    props: ['id', 'servicio', 'ffac','servicioext'],
    components: {
        facturacionfacturar,
        facturacionlistado,

},
    data() {
        return {
            no_factura: localStorage.getItem('no_factura'),
            togglecargar: 0,
            rutaventana:'',
        }
    },
    methods: {
        async finalizarSinFacturar() {
            //PUT  modulos/pwgsapi/index.php/facturas/:id_servicio/finalizar-sin-facturar
            try {
                if (confirm('¿Desea finalizar el servicio sin facturar?')) {
                    const api = new PwgsApi();
                    await api.put("facturas/" + this.$props.id + "/finalizar-sin-facturar");
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    let ventanas = this.$store.getters.ventanas;
                    let ventana = '';
                    let ventanaid = this.$props.id.toString();

                    for (let i = 0; i < ventanas.length; i++) {
                        ventana = this.$store.getters.ventanas[i].path;
                        if (ventana.includes(ventanaid)) {
                            this.rutaventana = this.$store.getters.ventanas[i];
                        }
                    }
                    this.$store.dispatch('quitarRuta', this.rutaventana);
                    this.$router.push({ name: 'Escritorio' });
                    
                }
              



            }
             catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        reload(){
            this.$refs.fac.reload();
            this.$refs.listado.reload();
        },
        movertoggle() {
            this.togglecargar = this.togglecargar + 1;
            this.$emit('facturado');
        }
    },
    mounted() {
    },
    watch: {

    }

}
</script>